export const WEEKDAYS_NUMBERS = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

export const WEEKDAYS_DAY_NAMES_SHORT = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

export const FEEDBACKS = {
  GOOD: 1,
  OK: 2,
  BAD: 3,
};

export const EMPTY_FEEDBACK = 0;

export const TFPL_SECURITY_HEADER = 'tfpl-id-token';
// Must match DEFAULT_HEADER_SERVICE_ACCOUNT_KEY in @tfpl/auth.
// Server-side AGW AuthGuard reads this exact header — do not change without
// also updating the lib.
export const TFPL_SERVICE_ACCOUNT_KEY_HEADER = 'tfpl-sa-key';
export const KIOSK_KEY_STORAGE_KEY = 'kioskKey';
export const KIOSK_PATH_PREFIX = '/kiosk/';

/**
 * sessionStorage flag marking that this tab already attempted the stale-bundle
 * auth recovery (service worker update + one hard reload). Guards against a
 * reload loop when the 401 is not caused by stale code. Cleared on a successful
 * auth boot so a later deploy mid-session can recover again.
 */
export const AUTH_RECOVERY_ATTEMPTED_KEY = 'hub-auth-recovery-attempted';

/**
 * sessionStorage timestamp of the last reload triggered by a failed chunk load.
 * A cooldown rather than a one-shot flag — a kiosk tab runs for weeks and has to
 * survive every deploy, not just the first one.
 */
export const STALE_BUNDLE_RELOAD_AT_KEY = 'hub-stale-bundle-reload-at';
